const REFERRALS = {
  FETCHING_ACTIVE_CAMPAIGNS: 'FETCHING_ACTIVE_CAMPAIGNS',
  FETCH_ACTIVE_CAMPAIGNS_SUCCESS: 'FETCH_ACTIVE_CAMPAIGNS_SUCCESS',
  FETCH_ACTIVE_CAMPAIGNS_FAILURE: 'FETCH_ACTIVE_CAMPAIGNS_FAILURE',

  GETTING_REDEEMED_COINS: 'GETTING_REDEEMED_COINS',
  GET_REDEEMED_COINS_SUCCESS: 'GET_REDEEMED_COINS_SUCCESS',
  GET_REDEEMED_COINS_FAILURE: 'GET_REDEEMED_COINS_FAILURE',

  GETTING_USER_REDEEMED_COINS: 'GETTING_USER_REDEEMED_COINS',
  GET_USER_REDEEMED_COINS_SUCCESS: 'GET_USER_REDEEMED_COINS_SUCCESS',
  GET_USER_REDEEMED_COINS_FAILURE: 'GET_USER_REDEEMED_COINS_FAILURE',

  COMPLETING_REDEEMED_COINS: 'COMPLETING_REDEEMED_COINS',
  COMPLETE_REDEEMED_COINS_SUCCESS: 'COMPLETE_REDEEMED_COINS_SUCCESS',
  COMPLETE_REDEEMED_COINS_FAILURE: 'COMPLETE_REDEEMED_COINS_FAILURE'
};

export default REFERRALS;
